<template>
    <div>
        <b-modal id="readerInfo" :title="'Інформація про читача ' + reader.code" size="size" footer-class="reader-footer" content-class="reader-content">
            <template v-slot:default>
                <div class="row" v-if="reader.hasOwnProperty('id')" id="profile-reader">
                    <div class="col-4">
                        <div class="reader-avatar reader-avatar-show">
                            <div class="dropify-wrapper">
                                <div class="dropify-preview" style="display: block;padding: 0px">
                                        <span class="dropify-render" :style="'background: url(' + (reader.photo ? '/uploads/' + reader.photo : '/images/avatar.png') +')'">
                                        </span>
                                </div>
                            </div>
                            <div style="width: 100%"></div>
                            <div class="fullname text-center">
                                <p>{{ reader.fullname }}</p>
                                <p>
                                  <i v-for="n in 3" class="mdi mdi-star star"></i><i class="mdi mdi-star-half star"></i><i class="mdi mdi-star-outline star"></i>
                                </p>
                                <button v-if="reader.debtor_days" class="btn btn-debtor"  style="width:100%;height: unset">
                                    Заборгованість {{ reader.debtor_days }}
                                    днів
                                </button>
                                <button v-else class="btn btn-debtor not-debtor" style="width:100%;height: unset">
                                    Немає заборгованості
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="row">
                            <div class="col-10">
                                <div class="phone">{{ reader.phone.substr(0, 10) + 'xxx-xx' + reader.phone.substr(16, 3) }}</div>
                            </div>
                            <div class="col-2">
                                <div class="text-right">
                                    <i v-if="reader.sms" class="mdi mdi-check-circle check"></i>
                                    <i v-else class="mdi mdi-check-circle uncheck"></i>
                                </div>
                            </div>
                        </div>
                        <div class="m-t-30">
                            <table class="table-show-reader m-t-10 w-100">
                                <tbody>
                                <tr>
                                    <td>
                                        Стать:
                                    </td>
                                    <td class="text-right">
                                        {{ reader.sex === 'man' ? 'Чоловік' : 'Жінка' }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Вік:
                                    </td>
                                    <td class="text-right">
                                        {{ reader.age }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Відвідування:
                                    </td>
                                    <td class="text-right">
                                        {{ reader.count_visits }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Підключення BankID:
                                    </td>
                                    <td class="text-right">
                                      <i v-if="reader.has_bank_id" class="mdi mdi-check-circle"></i>
                                      <i v-else class="mdi mdi-check-circle uncheck"></i>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Підписка:
                                    </td>
                                    <td class="text-right">
                                        <i v-if="reader.has_subscription == 1" class="mdi mdi-check-circle"></i>
                                        <i v-else class="mdi mdi-check-circle uncheck"></i>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class=" m-t-10" style="font-size: 14px">
                            <span class="table-show-reader">Реєстрація:</span>
                            <hr style="margin-top: 0">
                            <p v-if="reader.library_register">{{ moment(reader.created_at).format("DD.MM.YYYY HH:mm") }} • {{ reader.library_register.title }}</p>
                            <p v-else>{{ moment(reader.created_at).format("DD.MM.YYYY HH:mm") }} • З мобільного додатку</p>
                          <div v-if="reader.library_register && reader.library_register.id != $root.$data.libraryId && reader.library.find(el=> el.id == $root.$data.libraryId)">
                            <p>{{ moment(reader.library.find(el=> el.id == $root.$data.libraryId).pivot.created_at) }}
                            • {{ reader.library.find(el=> el.id == $root.$data.libraryId).title }}</p>
                          </div>

<!--                            <br><br>-->
<!--                            <span v-if="!isActive" style="color: #605CA8;">*Дійсний до {{ reader.date_end }}</span>-->
<!--                            <span v-else class="btn btn-debtor">*Не дійсний {{ reader.date_end }}</span>-->
                        </div>
                    </div>
                    <div class="col-4">
<!--                        <div class="reader-avatar text-left m-l-0" style="height: unset">-->
<!--                            <div class="col-10">-->
<!--                                <span style="font-size: 13px;font-weight: 500">Видані на руки книжки</span>-->
<!--                            </div>-->
<!--                            <div class="m-r-20">-->
<!--                                <div class="ellipse text-center">-->
<!--                                    {{ reader.books.length }}-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="books-readers m-t-20">-->
<!--                            <table class="table">-->
<!--                                <tbody>-->
<!--                                <tr v-for="book in reader.books">-->
<!--                                    <td class="title">-->
<!--                                      <a href="#" @click.prevent="$bvModal.hide('readerInfo');searchBook(book.code)">{{ book.description.title }}-->
<!--                                        <br>-->
<!--                                        <span class="table-show-reader">({{ book.example.title }})</span>-->
<!--                                      </a>-->
<!--                                    </td>-->
<!--                                    <td v-if="book.back_date < moment()" class="back-date debtor text-right">-->
<!--                                        {{ book.back_date }}-->
<!--                                        <br>-->
<!--                                        <b>{{ diffDays(book.back_date) }}-->
<!--                                            днів</b>-->
<!--                                    </td>-->
<!--                                    <td v-else class="back-date text-right">-->
<!--                                        {{ book.back_date }}-->
<!--                                    </td>-->
<!--                                </tr>-->
<!--                                </tbody>-->
<!--                            </table>-->
<!--                        </div>-->

<!--                        <div class="reader-avatar text-left m-l-0" style="height: unset">-->
<!--                            <div class="col-10">-->
<!--                                <span style="font-size: 13px;font-weight: 500">Заброньовані книжки</span>-->
<!--                            </div>-->
<!--                            <div class="m-r-20">-->
<!--                                <div class="ellipse text-center">-->
<!--                                    {{ reader.reserved_books.length }}-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="books-readers m-t-20">-->
<!--                            <table class="table">-->
<!--                                <tbody>-->
<!--                                <tr v-for="book in reader.reserved_books">-->
<!--                                    <td class="title">-->
<!--                                        <a href="#" @click.prevent=""> &lt;!&ndash;$bvModal.hide('readerInfo');searchBook(book.code)&ndash;&gt;-->
<!--                                            {{ book.description.title }}-->
<!--                                            <br>-->
<!--                                            <span class="table-show-reader"> </span> &lt;!&ndash;{{ book.example.title }}&ndash;&gt;-->
<!--                                        </a>-->
<!--                                    </td>-->
<!--                                    <td class="back-date text-right">-->
<!--                                        {{ moment(book.created_at).format("YYYY-MM-DD") }}-->
<!--                                        <br/>-->
<!--                                        {{ moment(book.created_at).format("hh:mm:ss") }}-->
<!--                                    </td>-->
<!--                                </tr>-->
<!--                                </tbody>-->
<!--                            </table>-->
<!--                        </div>-->

                        <div class="accordion" id="accordionExample">
                            <div>
                                <div class="reader-avatar text-left m-l-0" style="height: unset" id="headingOne">
                                    <div class="col-10">
                                        <button class="btn btn-link" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                            <span style="font-size: 13px;font-weight: 500">Видані на руки книжки</span>
                                        </button>
                                    </div>
                                    <div class="m-r-20">
                                        <div class="ellipse text-center">
                                            {{ reader.books.length }}
                                        </div>
                                    </div>
                                </div>

                                <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample" v-bind:class="{ show: !modal }">
                                    <div class="books-readers m-t-20">
                                        <table class="table">
                                            <tbody>
                                            <tr v-for="book in reader.books">
                                                <td class="title">
                                                    <a href="#" @click.prevent="$bvModal.hide('readerInfo');searchBook(book.code)">
                                                        {{ book.description.title }}
                                                        <br>
                                                        <span class="table-show-reader">({{ book.example.title }})</span>
                                                    </a>
                                                </td>
                                                <td v-if="moment().format('YYYY-MM-DD HH:mm:ss') > book.back_date" class="back-date debtor text-right">
                                                    {{ book.back_date }}
                                                    <br>
                                                    <b>{{ diffDays(book.back_date) }}
                                                        днів</b>
                                                </td>
                                                <td v-else class="back-date text-right">
                                                    {{ book.back_date }}
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="reader-avatar text-left m-l-0" style="height: unset" id="headingTwo">
                                    <div class="col-10">
                                        <button class="btn btn-link collapsed" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                            <span style="font-size: 13px;font-weight: 500">Заброньовані книжки</span>
                                        </button>
                                    </div>
                                    <div class="m-r-20">
                                        <div class="ellipse text-center">
                                            {{ reader.reserved_books.length }}
                                        </div>
                                    </div>
                                </div>
                                <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample" v-bind:class="{ show: modal }">
                                    <div class="books-readers m-t-20">
                                        <table class="table">
                                            <tbody>
                                            <tr v-for="book in reader.reserved_books">
                                                <td class="title">
                                                    <a href="" @click.prevent="$bvModal.hide('readerInfo');reservedBook(book.id)">
                                                        {{ book.description.title }}
                                                        <br>
                                                        <span class="table-show-reader"> </span> <!--{{ book.example.title }}-->
                                                    </a>
                                                </td>
                                                <td class="back-date text-right">
                                                    {{ moment(book.created_at).format("YYYY-MM-DD") }}
                                                    <br/>
                                                    {{ moment(book.created_at).format("hh:mm:ss") }}
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </template>

            <template v-slot:modal-footer>
                <div class="row w-100 text-center" v-if="reader.hasOwnProperty('id')">
                    <div class="col-4">
                        <a v-if="!isRegister" :href="'/library/reader/' + reader.id + '/edit/'" class="btn btn-success m-auto" style="padding:18px">
                          Зареєструвати
                        </a>
                        <a v-else-if="isActive" :href="'/library/reader/' + reader.id + '/edit/'" class="btn btn-outline-secondary debtor m-auto" style="padding:18px">
                          Перереєстрація
                        </a>
                        <a v-else :href="'/library/reader/' + reader.id" class="btn btn-outline-secondary m-auto" style="padding:18px">
                            Детальніше...
                        </a>
                    </div>
                    <div class="col-4">
                        <b-input-group v-if="reader.allow_get_book == 1">
                            <template v-slot:append>
                                <b-input-group-text class="button-index">
                                    <img src="/theme/icons/plus-multiple.svg">
                                </b-input-group-text>
                            </template>
                            <b-form-input type="search" class="input-index" placeholder="Додати книжку за номером" @change="giveBook($event, reader.id)"></b-form-input>
                        </b-input-group>
                    </div>
                    <div class="col-4 record-actions" v-if="reader.allow_get_book == 1">
                        <button class="btn btn-primary btn-record-default-action" @click="$root.startInternet(reader.id)" v-bind:class="{'single-action': isNoActions}">
                          Інтернет відвідування
                        </button>
                        <button v-if="!isNoActions" class="btn btn-primary btn-icon" @click.prevent="toggleActions()" v-bind:class="{active: showActions}">
                          <i class="mdi mdi-chevron-up mdi-36px"></i>
                        </button>
                        <div class="additional-actions" v-if="showActions">
                          <button class="btn btn-primary" v-for="item in actions" @click.prevent="recordAppeal(item.id)">
                            {{ item.name }}
                          </button>
                        </div>
                    </div>
                </div>
                <div class="row w-100 m-b-20 text-center" style="height:10px">
                    <div class="invalid-feedback">

                    </div>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
    export default {
        name: "ReaderInfo",
        props:['reader', 'modal'],
        data: function () {
          return {
            showActions: false,
            actions: []
          };
        },
        mounted() {
          this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
                if(modalId === 'readerInfo'){
                  this.showActions = false;
                  this.$root.$data.searchresults = {
                    reader: {
                      fullname: null,
                      address: null,
                      code: null,
                    },
                    booksearched: {
                        id: null,
                        code: null,
                        status_id: null,
                        description: {
                            title: null,
                            author: null,
                            publication: null
                        }
                    },
                    reservedbook: {
                        id: null,
                        title: null,
                    }
                  }
                }
            });

          axios.get('/library/actions')
              .then(response => response.data)
              .then(actions => this.actions = actions);
        },
        computed:{
          isRegister(){
            return typeof this.reader.library.find(el=>el.id == this.$root.$data.libraryId) != 'undefined';
          },
          isActive(){
            return new Date(new Date(this.reader.library.find(el=>el.id == this.$root.$data.libraryId).pivot.updated_at).getFullYear(),11,31) < new Date();
          },
          isNoActions() {
            return this.actions.length < 1;
          }
        },
        methods:{
            searchBook(event){
                this.$root.searchInLibrary(event);
                $('.input-index').val('');
            },
            reservedBook(event, reader_id){
                this.$root.reservedBook(event);
                $('.input-index').val('');
            },
            giveBook(event, reader_id){
                this.$root.giveBook(event, reader_id);
                $('.input-index').val('');
            },
            moment(date){
                return moment(date).format('YYYY-MM-DD');
            },
            moment: function (date) {
                return moment(date);
            },
            diffDays(date){
                return moment().diff(date, 'days');
            },
            recordAppeal(actionId) {
              axios.post('/library/record-appeal', {id: actionId, readerId: this.reader.id})
                  .then(response => response.data)
                  .then(response => Swal('Звернення зареєстровано!'))
                  .then(response => this.$root.$refs.events.getStories(true))
                  .then(() => this.$bvModal.hide('readerInfo'))
                  .catch(err => {
                    Swal({
                      text: "Звернення не зареєстровано!",
                      icon: "warning"
                    });
                  });
            },
            toggleActions(){
              this.showActions = !this.showActions;
            }
          },
    }
</script>

<style>
    .reader-footer{
        border-top: none;
    }
    .reader-content{
        border-radius: 16px;
    }
    .modal-title{
      color:#605CA8;
      font-size: 16px;
      font-weight:normal;
    }
    .modal-body{
      padding: 30px;
    }

</style>
<style scoped>
    .reader-avatar{
      height: unset;
    }
    .reader-avatar .fullname{
        font-size: 16px;
        padding-top: 20px;
    }
    .btn-primary{
        height: 60px;
        width: 100%;
        border-radius: 8px;
    }
    .reader-avatar .dropify-wrapper{
      width: 140px;
      height:140px;
    }
    .reader-avatar .dropify-wrapper .dropify-preview .dropify-render{
      width: 141px;
      height:141px;
      background-size: cover !important;
      background-position: center !important;
    }
    .books-readers{
      height: 280px;
    }
    .input-index{
      height: 60px;
    }
    .button-index{
      height: 60px;
    }
    .btn.debtor{
      background-color: #FE9780;
      color: white;
      border: none;
    }
    .record-actions {
      display: flex;
      position: relative;
    }
    .btn-record-default-action:not(.single-action) {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    .btn-icon {
      width: auto;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      border-left: 1px solid #005cbf;
    }
    .additional-actions {
      position: absolute;
      left: 0;
      bottom: 100%;
      width: 100%;
      box-sizing: border-box;
      padding-left: 15px;
      padding-right: 15px;
      padding-bottom: 6px;
    }
    .additional-actions .btn {
      margin-bottom: 8px;
      width: 100%;
      display: block;
    }
    .additional-actions .btn, .btn-icon, .btn-record-default-action {
      margin-top: 0;
    }
</style>
